import {React} from '@api'
import { VipLocalStore } from '@modules/VipLocalStore'
import {ICatalogPresetES, StoresInstance} from '@stores'
import {action, autorun, computed, observable} from 'mobx'

export class WorkspacePresetDialogStore extends VipLocalStore {
  constructor(stores: StoresInstance) {
    super(stores)

    const {presets} = this
    presets.dialogStore = this

    autorun(() => {
      const {dialogPreset} = presets
      if (dialogPreset) {
        this.preset = dialogPreset
      }
    })
  }

  get presets() {return this.stores.presets}
  get currentUser() { return this.stores.currentUser}

  @observable preset: ICatalogPresetES

  @computed get open() {
    return this.presets.dialogPreset != null
  }

  @computed get title() {
    const {preset} = this
    if (!preset) return ''

    if (!preset._id) {
      return 'Save Preset'
    }

    return `Edit Preset '${preset.label}'`
  }

  @action onChangePresetLabel = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.preset.label = e.currentTarget.value
  }

  @action onNamePresetKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      this.onOK()
    }
  }

  @computed get readonly() {
    return this.preset?.creator != null && this.preset?.creator !== this.currentUser?.info?.id
  }

  @action onOK = async () => {
    const {presets} = this
    if (this.readonly) {
      presets.dialogPreset = {...this.preset, copiedFromId: this.preset._id, _id: null, creator: this.currentUser.info.id, creationDate: new Date().getUTCDate()}
    } else {
      await presets.savePreset(this.preset)
      presets.dialogPreset = null
    }
  }

  @action onCancel = () => {
    this.presets.dialogPreset = null
  }

  @action onTogglePublic = () => {
    this.preset.public = !this.preset.public
  }
}

export const WorkspacePresetDialogStoreContext = React.createContext<WorkspacePresetDialogStore>(null)
export const useWorkspacePresetDialogStore = () => React.useContext(WorkspacePresetDialogStoreContext)



// WEBPACK FOOTER //
// ./src/stores/workspace/WorkspacePresetsDialogStore.ts